<kpd-confirm-dialog key="confirmRoleUserDelete"></kpd-confirm-dialog>
<kpd-secure-action-dialog key="secureDelete"></kpd-secure-action-dialog>
<app-link-entities
  key="linkEntities"
  [cols]="linkUsersCols"
  [searchConfig]="linkUsersSearchConfig"
  [header]="'Link users' | translate"
></app-link-entities>

<kpd-hotkey keys="up" (action)="onPrevious()"></kpd-hotkey>
<kpd-hotkey keys="left" (action)="onPrevious()"></kpd-hotkey>
<kpd-hotkey keys="down" (action)="onNext()"></kpd-hotkey>
<kpd-hotkey keys="right" (action)="onNext()"></kpd-hotkey>

<div class="detail__grid" *ngIf="isRoleAvailable()">
  <div class="detail__alert">
    <kpd-alert type="warning" *ngIf="!canManageRole" icon="warning-standard" translate>
      You don't have all the permissions linked to this role to assign or remove users from it
    </kpd-alert>
    <ng-container *ngIf="saveErrors.length > 0">
      <kpd-alert type="error" *ngFor="let error of saveErrors" icon="warning-standard"> {{ error }} </kpd-alert>
    </ng-container>
  </div>

  <div class="detail__toolbar" *ngIf="!readOnlyMode">
    <kpd-action-bar *kpdPermission="Permissions.UserRoleUpdate">
      <kpd-action-create (action)="onAdd()" [disable]="!canManageRole"> </kpd-action-create>
      <kpd-action-delete
        (action)="onDelete()"
        [disable]="
          selectedKeys.length === 0 || !canManageRole || (isSystemUserSelected && !hasSystemUserManagePermission)
        "
      >
      </kpd-action-delete>
    </kpd-action-bar>
  </div>

  <div class="detail__main">
    <p-table
      dataKey="key"
      [value]="items"
      [scrollable]="true"
      class="table__fullheight"
      [resizableColumns]="true"
      [columns]="columnsConfig"
      [reorderableColumns]="true"
      kpdTableColumnReorder
      kpdTableSaveColumns="roleDetailsUsers"
      kpdTableScroll
      [selectionMode]="readOnlyMode ? null : 'multiple'"
      [kpdTableRowSelection]="selectedKeys"
      [metaKeySelection]="true"
      [index]="index"
      kpdTableShiftClick
      (selectionChanged)="onSelectionChanged($event)"
      kpdDisableTextSelectionOnShiftClick
      (kpdTableSort)="onSort($event)"
    >
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" translate>No records found</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style.width]="col.width" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td *ngFor="let col of columns">
            <ng-container *ngIf="col.field !== 'upn'">
              {{ rowData[col.field] }}
            </ng-container>
            <a
              [kpdLinkClick]="rowData.getDetailUrl()"
              (clickEvent)="navigateToUser(rowData.key)"
              *ngIf="col.field === 'upn'"
            >
              {{ rowData[col.field] }}
            </a>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
